import React, { useEffect, useState } from "react";
import "../../../simplelocker.css";
import styles1 from "./style1.module.css";
import login1 from "../../../images/login1.svg";
import { Link, useNavigate, useParams } from "react-router-dom";
import { notification } from "antd";
import { loginSuccess,setSiteName } from "../../Redux/Authentication";
// import { toast } from "react-toastify";
import { useDispatch } from "react-redux";
const Logo = "/invid_logo.png?v=2";
const url = process.env.REACT_APP_APP_BACK_URL;

let headers = new Headers();
headers.append("Content-Type", "application/json");
headers.append("Access-Control-Allow-Origin", "*");
headers.append("Access-Control-Allow-Credentials", "true");

const SiteUser = () => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [credentials, setCredentials] = useState({ name: "" });
  const handleInput = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };
  const formSubmit = async (e) => {
    try {
      e.preventDefault();
      let headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("Access-Control-Allow-Origin", "*");
      headers.append("Access-Control-Allow-Credentials", "true");
      setIsLoading(true);
      const response = await fetch(`${url}/api/sites/check_site`, {
        mode: "cors",
        method: "POST",
        headers: headers,
        body: JSON.stringify({
          slug: credentials.name,
        }),
      });
      setIsLoading(false);
      const json = await response.json();
      if (json.success) {
        localStorage.setItem("siteuser", credentials.name);
        localStorage.setItem("site_logo", json.site_logo);
        sessionStorage.setItem("siteuser", credentials.name);

        localStorage.setItem("site_logo", json.site_logo);

        navigate(`/${credentials.name}/pin`);
      } else {
        notification.error({
          message: "Failed",
          description: json.error,
          duration: 3,
        });
        //   toast.error(json.error);
      }
    } catch (error) {
      setIsLoading(false);
      notification.error({
        message: "Error",
        description: error.message,
        duration: 3,
      });
    }
  };
  const getCurrentDate = () => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();

    return;
  };
  //   const checkPinRequired = async (name) => {
  //     try {
  //       let headers = new Headers();
  //       headers.append("Content-Type", "application/json");
  //       headers.append("Access-Control-Allow-Origin", "*");
  //       headers.append("Access-Control-Allow-Credentials", "true");
  //       setIsLoading(true);

  //       const response = await fetch(`${url}/api/auth/code`, {
  //         mode: "cors",
  //         method: "POST",
  //         headers: headers,
  //         body: JSON.stringify({
  //           name: getCurrentDate(),
  //           slug: name,
  //         }),
  //       });
  //       setIsLoading(false);

  //       const json = await response.json();

  //       if (json.success) {
  //         const user = json.user;
  //         const expirationTime = Math.floor(Date.now() / 1000) + 7200;
  //         localStorage.setItem("token", json.authToken);
  //         localStorage.setItem("token-expiration", expirationTime);
  //         dispatch(loginSuccess(json.user));
  //         // toast.success(" Successfully login Successfully");
  //         if (user.role === "user") {
  //           navigate(`/${name}/dashboard1`);
  //         } else if (user.role === "admin") {
  //           navigate(`/${name}/timer`);
  //         } else {
  //           toast.error("Enter valid pin");
  //         }
  //       } else {
  //         toast.error(json.error);
  //       }
  //     } catch (error) {
  //       setIsLoading(false);
  //       toast.error(error.message);
  //       console.log(error);
  //     }
  //   };
  const iocnStyle = {
    display: isLoading ? "inline-block" : "none",
  };
  useEffect(() => {
    const siteuser = localStorage.getItem("siteuser");
    (async () => {
      if (siteuser) {
        setCredentials({ ...credentials, name: siteuser });
        const response = await fetch(`${url}/api/sites/check_site`, {
          mode: "cors",
          method: "POST",
          headers: headers,
          body: JSON.stringify({
            slug: siteuser,
          }),
        });
        const json = await response.json();

        if (json.success) {
          //   if (!json.required_pin) {
          //     checkPinRequired(siteuser);
          //     return;
          //   }
          console.log(json);
          // notification.success({
          //   message: "Success",
          //   description: "Enter pin to login",
          //   duration: 3,
          // });
          //   toast.success("Enter pin to login ");
          navigate(`/${siteuser}/pin`);
        } else {
          notification.error({
            message: "Failed",
            description: json.error,
            duration: 3,
          });
          //   toast.error(json.error);
        }
      }
    })();
  }, []);

  return (
    <div className={styles1.heading}>
      <div className="body-wrap">
        <div className="container-fluid px-0">
          <div className={styles1.body_wrap}>
            <div className="login-container">
              <div className="image-container d-flex justify-content-center align-items-center mt-5">
                <img
                  src={Logo}
                  alt="logo"
                  style={{ maxWidth: "220px", width: "100%", height: "auto" }}
                />
              </div>
              <form className="form-container" onSubmit={formSubmit}>
                <div className="mb-3">
                  <input
                    type="text"
                    className="form-control"
                    id="exampleInputPassword1"
                    name="name"
                    placeholder="Enter Site User Name.."
                    value={credentials.name}
                    autoComplete="off"
                    onChange={handleInput}
                    required
                  />
                </div>
                <button
                  type="submit"
                  disabled={isLoading}
                  href=""
                  className="btn btn-prim"
                >
                  <i className="fa fa-spinner fa-spin" style={iocnStyle}></i>{" "}
                  <span className="fw-700 fs-5">Enter</span>
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default SiteUser;
